function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Renders an admin-entered product description one line at a time.
 *
 * If the content already contains structured HTML (paragraphs, divs, line
 * breaks, lists, headings, tables, images...), it is returned untouched so the
 * admin's formatting is always preserved. Plain-text content is split into
 * paragraphs line by line, with "- / * / • / numbered" bullet lines shown as
 * readable list lines.
 */
export function formatDescription(html?: string | null): string {
  if (!html) return '';
  const trimmed = html.trim();
  if (!trimmed) return '';
  if (/<(p|div|br|ul|ol|li|h[1-6]|table|img|section|article)[\s>/]/i.test(trimmed)) {
    return trimmed;
  }

  const lines = trimmed.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
  return lines.map(line => {
    const bulletMatch = line.match(/^([-*•])\s+(.*)$/);
    if (bulletMatch) {
      return `<p class="description-line description-bullet">${escapeHtml(bulletMatch[2])}</p>`;
    }
    const numMatch = line.match(/^(\d+)[.)]\s+(.*)$/);
    if (numMatch) {
      return `<p class="description-line description-numbered">${escapeHtml(`${numMatch[1]}. ${numMatch[2]}`)}</p>`;
    }
    return `<p class="description-line">${escapeHtml(line)}</p>`;
  }).join('');
}